import styles from './Breadcrumbs.module.scss';
import Text from '../Text/TextComponent';
import { ReactSVG } from 'react-svg';
import { dataResources } from '@portal-internet/core';
import { Fragment } from 'react';

const { basePath } = dataResources;

export default function BreadcrumbsComponent({ breadcrumbs = [] }) {
    const numBreadcrumbs = breadcrumbs.length - 1;

    return (
        <div className={styles.redlBreadcrumbs}>
            <div className={styles.redlBreadcrumbsList} data-testid="REDL-breadcrumb">
                {breadcrumbs.map((breadcrumb, index) => (
                    <Fragment key={index}>
                        <Text tag="span" size="md" weight="400">{breadcrumb}</Text>
                        {index >= 0 && index < numBreadcrumbs ?
                            <ReactSVG
                                className={styles.redlBreadcrumbsIcon}
                                src={basePath + '/_resources/REDL/icons/chevron-right.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                            : null}
                    </Fragment>
                ))}
            </div>
        </div>
    );
}